import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AppService } from './app.service'
import { NgxSpinnerService } from 'ngx-spinner';
import { environment } from '../environments/environment';

@Component({
    selector: 'register-form',
    providers: [AppService],
    styleUrls: ['./register.component.css'],
    template: `
    <div class="register-container">
        <div class="register-card">
            <h1 class="register-title">Register</h1>
            
            <div class="form-group">
                <label class="form-label">Mobile Number</label>
                <input 
                    class="form-input" 
                    type="tel"
                    inputmode="numeric"
                    pattern="[0-9]*"
                    placeholder="Enter your mobile number"
                    [(ngModel)]="registerData.username" 
                />
                <div class="form-hint">Example: 4915212345678</div>
            </div>
            
            <div class="form-group">
                <label class="form-label">PIN</label>
                <input 
                    class="form-input"
                    autocomplete="new-password"
                    type="password"
                    inputmode="numeric"
                    pattern="[0-9]*"
                    placeholder="Enter your personal 4-digit Tantum PIN"
                    [(ngModel)]="registerData.password"
                />
            </div>
            
            <div class="form-group">
                <label class="form-label">Re-enter PIN</label>
                <input 
                    class="form-input" 
                    type="password" 
                    autocomplete="new-password"
                    inputmode="numeric"
                    pattern="[0-9]*"
                    placeholder="Enter your PIN again"
                    [(ngModel)]="registerData.password1"
                />
            </div>

            <!-- Consent Checkboxes -->
            <div class="consent-group">
                <label class="consent-checkbox">
                  <input type="checkbox" class="consent-input" required [(ngModel)]="consentChecked">
                  <span class="consent-text">
                    I agree to the <a href="https://tantumpay.com/en/terms-and-conditions/" target="_blank" rel="noopener noreferrer">terms and conditions</a> and to the processing of my identification data and biometric data for the purpose of carrying out the identification and verification process in accordance with the provisions in the <a href="https://tantumpay.com/en/privacy-policy/" target="_blank" rel="noopener noreferrer">privacy policy</a>.
                  </span>
                </label>
            </div>

            <button class="register-button" (click)="register()" type="submit" [disabled]="!consentChecked">
                Register
            </button>
             <div class="action-links">
                <button class="register-link" (click)="login()" type="button">
                    Already have an account? Login
                </button>
            </div>
            <ngx-spinner size="medium" [type]="typeSelected"></ngx-spinner>
        </div>
    </div>`
})
export class RegisterComponent {
    public registerData = { username: "", password: "", password1: "", recaptchaResponse: "" };
    typeSelected: string;
    consentChecked: boolean = false;
    ACTION = 'signup';
    private captchaRetries = 0;
    private maxRetries = 50; // 10 secondi (50 * 200ms)

    constructor(private _service: AppService, private spinnerService: NgxSpinnerService, private router: Router) {
        this.typeSelected = 'ball-fussion';
    }

    ngOnInit() {
        // Sottoscrizione per rigenerare il captcha quando c'è un errore
        this._service.regenerateCaptcha$.subscribe(() => {
            this.regenerateCaptcha();
        });

        // Aspetta che il DOM sia completamente caricato
        if (document.readyState === 'complete') {
            this.requestRecaptchaV3Token();
        } else {
            window.addEventListener('load', () => {
                setTimeout(() => this.requestRecaptchaV3Token(), 500);
            });
        }
    }

    requestRecaptchaV3Token(): void {
        // Verifica se window.grecaptcha esiste
        const globalgrecaptcha = (window as any).grecaptcha;

        if (typeof globalgrecaptcha === 'undefined' || !globalgrecaptcha || !globalgrecaptcha.enterprise) {
            this.captchaRetries++;
            if (this.captchaRetries >= this.maxRetries) {
                console.error('reCAPTCHA script failed to load after ' + this.maxRetries + ' retries');
                this.registerData.recaptchaResponse = 'captcha-load-failed';
                return;
            }
            console.log('grecaptcha not loaded yet, retrying... (' + this.captchaRetries + '/' + this.maxRetries + ')');
            setTimeout(() => this.requestRecaptchaV3Token(), 200);
            return;
        }

        try {
            globalgrecaptcha.enterprise.ready(() => {
                globalgrecaptcha.enterprise.execute(environment.captcha_key, { action: this.ACTION })
                    .then((token: string) => {
                        this.registerData.recaptchaResponse = token;
                        console.log('reCAPTCHA v3 token:', token);
                    })
                    .catch((error: any) => {
                        console.error('reCAPTCHA execute error:', error);
                        this.registerData.recaptchaResponse = 'captcha-execute-failed';
                    });
            });
        } catch (error) {
            console.error('reCAPTCHA ready error:', error);
            this.registerData.recaptchaResponse = 'captcha-ready-failed';
        }
    }

    regenerateCaptcha(): void {
        // Reset dei retry e rigenera il token
        this.captchaRetries = 0;
        console.log('Regenerating captcha token...');
        this.requestRecaptchaV3Token();
    }

    public showSpinner(): void {
        this.spinnerService.show();
    }

    login() {
        this.router.navigate(['/prelogin']);
    }

    register() {
        this.showSpinner();
        if (this.registerData.password !== this.registerData.password1) {
            alert("Pin not the same");
            this.registerData.password = this.registerData.password1 = ""
            return;
        }
        if (this.registerData.username.indexOf('+') != -1) {
            this.registerData.username = this.registerData.username.substring(1);
        }
        if (this.registerData.username.substring(0, 2) == "00") {
            this.registerData.username = this.registerData.username.substring(2);
        }

        // Rimuove tutti i caratteri non numerici da username
        this.registerData.username = this.registerData.username.replace(/\D/g, '');

        this._service.register(this.registerData);
    }
}
